import React, { useEffect, useState } from "react";
import { Modal, Button, Typography } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import cortesiaService from "services/CortesiaService";

const { Title, Paragraph, Text } = Typography;

/**
 * Avisa o profissional que o período gratuito (cortesia) está acabando.
 * Tudo é decidido no back (deve_mostrar: ≤3 dias do término, ainda na cortesia,
 * não contratou, 1x/dia). O modal não fecha sozinho: o profissional precisa
 * clicar em "Contratar plano" ou "Entendi", e os dois registram a prova.
 */
const CortesiaFimModal = () => {
	const [visible, setVisible] = useState(false);
	const [aviso, setAviso] = useState(null);
	const [acaoLoading, setAcaoLoading] = useState(null); // "ok" | "contratar"
	const history = useHistory();

	useEffect(() => {
		let ativo = true;
		(async () => {
			try {
				const resp = await cortesiaService.getAvisoFimCortesia();
				if (ativo && resp?.deve_mostrar) {
					setAviso(resp);
					setVisible(true);
				}
			} catch (e) {
				/* silencioso: check de background */
			}
		})();
		return () => {
			ativo = false;
		};
	}, []);

	const reconhecer = async (acao) => {
		setAcaoLoading(acao);
		try {
			await cortesiaService.reconhecerAviso(acao);
		} catch (e) {
			/* o aviso reaparece em outro dia; não trava o usuário */
		} finally {
			setAcaoLoading(null);
		}
	};

	const handleEntendi = async () => {
		await reconhecer("ok");
		setVisible(false);
	};

	const handleContratar = async () => {
		await reconhecer("clicou_contratar");
		setVisible(false);
		history.push(`${APP_PREFIX_PATH}/assinatura`);
	};

	const dias = aviso?.dias_restantes;
	const quando =
		dias === undefined || dias <= 0
			? "hoje"
			: dias === 1
			? "amanhã"
			: `em ${dias} dias`;

	return (
		<Modal
			open={visible}
			footer={null}
			width={460}
			centered
			closable={false}
			maskClosable={false}
			keyboard={false}
			bodyStyle={{ padding: 0, borderRadius: 12, overflow: "hidden" }}
			style={{ borderRadius: 12 }}
		>
			<div
				style={{
					background:
						"linear-gradient(135deg, #ff8034 0%, #ff5722 100%)",
					padding: "28px 24px",
					textAlign: "center",
					color: "#fff",
				}}
			>
				<ClockCircleOutlined
					style={{ fontSize: 46, marginBottom: 12 }}
				/>
				<Title
					level={3}
					style={{
						color: "#fff",
						margin: 0,
						fontSize: 21,
						fontWeight: 700,
					}}
				>
					Seu período gratuito está acabando
				</Title>
				<Text
					style={{ color: "rgba(255,255,255,0.92)", fontSize: 14 }}
				>
					Termina {quando}
				</Text>
			</div>

			<div style={{ padding: "24px 28px 22px" }}>
				<Paragraph style={{ fontSize: 14, marginBottom: 12 }}>
					Seu acesso gratuito ilimitado <strong>termina {quando}</strong>.
					Quando ele acabar, sua conta volta para o plano gratuito e os
					alunos que excedem o limite ficam <strong>inativos</strong>.
				</Paragraph>
				<Paragraph style={{ fontSize: 14, marginBottom: 20 }}>
					Para continuar com todos os seus alunos ativos, contrate um
					plano antes do término.
				</Paragraph>

				<Button
					type="primary"
					size="large"
					block
					onClick={handleContratar}
					loading={acaoLoading === "contratar"}
					style={{ height: 46, fontWeight: 600, marginBottom: 12 }}
				>
					Contratar plano
				</Button>
				<Button
					block
					onClick={handleEntendi}
					loading={acaoLoading === "ok"}
					style={{ height: 42 }}
				>
					Entendi
				</Button>
			</div>
		</Modal>
	);
};

export default CortesiaFimModal;
